import { Button } from "wiz-front-shared/components/button/Button";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { resetSignUpData, signUpDataAtom, signUpHistoryDepthAtom, setSignUpExiting } from "store/signUpStore";
import './SignUpStep8.css';

// Step10: 가입 불가 (서비스 가입 연령 정책)
//   Step8(실패) 과 같은 dead-end 화면 — 로그인으로 돌아가는 버튼만 제공
export const SignUpStep10 = () => {
    const { t } = useTranslation();
    const signUpData = useAtomValue(signUpDataAtom);
    const resetSignUp = useSetAtom(resetSignUpData);
    const historyDepth = useAtomValue(signUpHistoryDepthAtom);

    const message = signUpData.policyBlockReason === "AGE_BELOW_SERVICE_MIN"
        ? t("signUp.step10.ageBelowServiceMin")
        : t("signUp.step10.minorNotAllowed", { age: signUpData.consentAge });

    const handleGoToLogin = () => {
        setSignUpExiting(true);
        window.history.go(-(historyDepth + 1));
        setTimeout(() => resetSignUp(), 0);
    };

    return (
        <div className="sign-up-step-8" style={{ display: "flex" }}>
            <div className="sign-up-step-8-content">
                <span className="sign-up-step-8-title">{t("signUp.step10.title")}</span>
                <span className="sign-up-step-8-message">{message}</span>
            </div>
            <div className="sign-up-bottom-btn">
                <Button
                    text={t("signInText")}
                    onPress={handleGoToLogin}
                />
            </div>
        </div>
    );
};
